import React from 'react'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../store'
import Loader from '../../../components/Loader'
import { HealthState, setForWho, setInsured } from '../../../store/healthSlice'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthWhoDoYouInsure = () => {
  //
  //
  const dispatch = useAppDispatch()
  //
  const { checkout, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const navigate = useNavigate()
  //

  //
  //fake data
  const insureChoice = {
    id: 32,
    createdAt: '2023-10-04T14:05:41.517+04:00',
    updatedAt: '2023-10-04T14:05:41.517+04:00',
    translations: {
      ge: {
        title: 'Who do you insure?',
        stepName: 'ვისთვის ყიდულობ დაზღვევას?',
      },
      en: {
        title: 'Who do you insure?',
        stepName: 'Who do you insure?',
      },
    },
    listItems: [
      {
        id: 80,
        listId: 32,
        sort: 1,
        type: 'for-me',
        image:
          'https://d3cd9cyzr3ifxh.cloudfront.net/images/1a.v1k2l00ic-%E1%83%A9%E1%83%94%E1%83%9B%E1%83%97%E1%83%95%E1%83%98%E1%83%A1.png',
        translations: {
          ge: {
            title: 'ჩემთვის',
          },
          en: {
            title: 'For me',
          },
        },
        createdAt: '2023-10-04T14:05:41.533+04:00',
        updatedAt: '2023-10-26T14:45:05.411+04:00',
        title: 'For me',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. ',
      },
      {
        id: 81,
        listId: 32,
        sort: 2,
        type: 'for-other',
        image:
          'https://d3cd9cyzr3ifxh.cloudfront.net/images/15.78hlnlvgl-%E1%83%A1%E1%83%AE%E1%83%95%E1%83%98%E1%83%A1%E1%83%97%E1%83%95%E1%83%98%E1%83%A1.png',
        translations: {
          ge: {
            title: 'სხვისთვის',
          },
          en: {
            title: 'For other',
          },
        },
        createdAt: '2023-10-04T14:05:41.533+04:00',
        updatedAt: '2023-10-26T14:45:15.483+04:00',
        title: 'For other',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. ',
      },
      {
        id: 83,
        listId: 32,
        sort: 2,
        type: 'for-me-and-other',
        image:
          'https://d3cd9cyzr3ifxh.cloudfront.net/images/20.tci5rlm1fg-%E1%83%A9%E1%83%94%E1%83%9B%E1%83%97%E1%83%95%E1%83%98%E1%83%A1-%E1%83%93%E1%83%90-%E1%83%A1%E1%83%AE%E1%83%95%E1%83%98%E1%83%A1%E1%83%97%E1%83%95%E1%83%98%E1%83%A1.png',
        translations: {
          ge: {
            title: 'ჩემთვის და სხვისთვის',
          },
          en: {
            title: 'For me & other',
          },
        },
        createdAt: '2023-10-04T14:05:41.533+04:00',
        updatedAt: '2023-10-26T14:45:15.483+04:00',
        title: 'For me & other',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. ',
      },
    ],
  }

  //
  const stepName = insureChoice.translations[lang].stepName
  //
  const isInsureChoiceLoading = false
  //
  const mainLoading = isInsureChoiceLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('WhoDoYouInsure')} />

        <HealthProgressbar stepName={stepName} />

        <Cards>
          {insureChoice &&
            insureChoice?.listItems?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  disabled={false}
                  title={item?.translations?.[lang].title}
                  imgUrl={item?.image}
                  selected={item.type === checkout.forWho ? true : false}
                  onClick={() => {
                    dispatch(setForWho(item.type))
                    dispatch(setInsured(undefined))
                  }}
                ></HorizontalCard>
              )
            })}
        </Cards>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/health-offer')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={checkout.forWho ? false : true}
            onClick={() =>
              navigate(
                checkout.forWho === 'for-me'
                  ? '/health-for-me'
                  : checkout.forWho === 'for-other'
                  ? '/health-for-other'
                  : checkout.forWho === 'for-me-and-other'
                  ? '/health-for-me-and-other'
                  : '',
              )
            }
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  width: min-content;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Cards = styled.div`
  margin-top: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 464px;
  width: 100%;
  gap: 24px;

  ${Responsive.mobile} {
    margin-top: 27px;
    min-width: unset;
  }
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  /*  */
`

export default HealthWhoDoYouInsure
